import { LoadingStatusEnum } from '../../../constants/enums';

const initialState = {
  list: [],
  loading: LoadingStatusEnum.Idle,
  mutationLoading: LoadingStatusEnum.Idle,
  history: {
    taskId: null,
    list: [],
    loading: LoadingStatusEnum.Idle,
  },
};

export default initialState;
